/*=========================================================================================
  File Name: modulePartnerActions.js
  Description: Partner Module Actions
==========================================================================================*/

import api from "../../api/apiService"

export default {

    // partner list
    fetchPartners({ commit }, payload) {
      commit('SET_PARTNERS', [])
      api.partner(true, 'list', payload, (res) => {
        if (res.success && res.msg == 'ok') {
          commit('SET_PARTNERS', res.data)
        }
      });
    },

    // partner
    fetchPartner({ commit }, payload) {
      commit('SET_PARTNER', {})
      return api.partner(true, 'list', payload, (res) => {
        if (res.success && res.msg == 'ok') {
          commit('SET_PARTNER', res.data[0])
        }
      });
    },

    // partner create
    createPartner({ commit }, payload) {
      api.partner(true, 'create', payload, (res) => {
        if (res.success && (res.msg == 'ok')) {
          payload.partid = res.partid;
          commit('CREATE_PARTNER', payload);
          api.emitNotifyEvent({
            title: 'Создание нового партнера',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Создание нового партнера',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // partner edit
    updatePartner({ commit }, payload) {
      api.partner(true, 'edit', payload, (res) => {
        if (res.success && (res.msg == 'ok' || res.msg == 'no change')) {
          commit('UPDATE_PARTNER', payload)
          api.emitNotifyEvent({
            title: 'Редактирование партнера',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Редактирование партнера',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // partner delete
    deletePartner({ commit }, payload) {
      api.partner(true, 'delete', { partid: payload.partid }, (res) => {
        if (res.success && (res.msg == 'ok')) {
          commit('DELETE_PARTNER', payload)
          api.emitNotifyEvent({
            title: 'Удаление партнера',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Удаление партнера',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // program search
    setProgramSearchQuery({ commit }, query){
      commit('SET_PROGRAM_SEARCH_QUERY', query)
    },

    // program list
    fetchPrograms({ commit }, payload) {
      commit('SET_PROGRAMS', [])
      api.partner_program(true, 'list', payload, (res) => {
        if (res.success && res.msg == 'ok') {
          commit('SET_PROGRAMS', res.data)
        }
      });
    },

    // program create
    createProgram({ commit }, program) {
      api.partner_program(true, 'create', program, (res) => {
        if (res.success && (res.msg == 'ok')) {
          commit('ADD_PROGRAM', Object.assign(program, {ppid: res.ppid, state: 0}))
        }
      });
    },

    // program edit
    updateProgram({ commit }, program) {
      api.partner_program(true, 'edit', program, (res) => {
        if (res.success && (res.msg == 'ok' || res.msg == 'no change')) {
          commit('UPDATE_PROGRAM', program)
          api.emitNotifyEvent({
            title: 'Редактирование партнерской программы',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Редактирование партнерской программы',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // program delete
    deleteProgram({ commit }, program) {
      api.partner_program(true, 'delete', { ppid: program.ppid }, (res) => {
        if (res.success && res.msg == 'ok') {
            commit('DELETE_PROGRAM', program)
        }
      });
    },




    // device list
    fetchDevices({ commit }, payload) {
      commit('SET_DEVICES', [])
      api.partner_device(true, 'list', payload, (res) => {
        if (res.success && res.msg == 'ok') {
          commit('SET_DEVICES', res.data)
        }
      });
    },

    // device create
    createDevice({ commit }, payload) {
      let did_str = '';
      let first = true;
      payload.devices.forEach(value => {
        if (!first) {
          did_str += ','
        }
        first = false
        did_str += value.did
      })
      api.partner_device(true, 'create', {partid: payload.partid, descr: payload.descr, did: did_str}, (res) => {
      // api.partner_device(true, 'create', {debug: 1, partid: payload.partid, descr: payload.descr, did: did_str}, (res) => {
        if (res.success && (res.msg == 'ok')) {
          // commit('ADD_DEVICE', Object.assign(payload, {ppid: res.ppid, state: 0}))
          api.emitNotifyEvent({
            title: 'Связывание устройств с партнером',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else if (res.msg == 'access denied') {
          api.emitNotifyEvent({
            title: 'Связывание устройств с партнером',
            text: "Если одно или несколько устройств уже привязаны к партнеру, то необходимо их отвязать. Устройство должно быть разрешено.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Связывание устройств с партнером',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // device edit
    updateDevice({ commit }, payload) {
      api.partner_device(true, 'edit', payload, (res) => {
        if (res.success && (res.msg == 'ok' || res.msg == 'no change')) {
          commit('UPDATE_DEVICE', payload)
          api.emitNotifyEvent({
            title: 'Редактирование устройства партнера',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Редактирование устройства партнера',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // devices update state
    updateDevicesState({ commit }, payload) {
      let pdid_str = '';
      let first = true;
      payload.devices.forEach(value => {
        if (!first) {
          pdid_str += ','
        }
        first = false
        pdid_str += value.pdid
      })
      api.partner_device(true, 'edit', {state: payload.state, pdid: pdid_str}, (res) => {
        if (res.success && (res.msg == 'ok' || res.msg == 'no change')) {
          // commit('UPDATE_DEVICE', payload)
          api.emitNotifyEvent({
            title: 'Изменение статуса устройств',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Изменение статуса устройств',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // device delete
    deleteDevices({ commit }, payload) {
      let pdid_str = '';
      let first = true;
      payload.forEach(value => {
        if (!first) {
          pdid_str += ','
        }
        first = false
        pdid_str += value.pdid
      })
      api.partner_device(true, 'delete', { pdid: pdid_str }, (res) => {
      // api.partner_device(true, 'delete', { pdid: pdid_str, debug: 1 }, (res) => {
        if (res.success && res.msg == 'ok') {
          commit('DELETE_DEVICES', payload)
          api.emitNotifyEvent({
            title: 'Отвязывание устройств от партнера',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Отвязывание устройств от партнера',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

}
